import React from "react";

import GridBarFiltersAtomCheckbox from "@/components/Grid/Bar/Filters/Atom/Checkbox";
import LayoutSidebarFiltersAtomHeader from "@/components/Grid/Bar/Filters/Atom/Header";

export default function LayoutSidebarFiltersUnauthenticated() {
  return (
    <LayoutSidebarFiltersAtomHeader name="unauthenticated" hideCount>
      <GridBarFiltersAtomCheckbox filter="unauthenticated" label="Show vaults that aren't authenticated OR linked to authenticated protocols" />
    </LayoutSidebarFiltersAtomHeader>
  );
}
